import { useEffect, useState } from 'react';

type Principal = { userDetails?: string; userRoles?: string[] } | null;

export default function NotInvitedPage() {
  const [principal, setPrincipal] = useState<Principal>(null);
  const [loaded, setLoaded] = useState(false);
  const isFr = (navigator.language || 'en').toLowerCase().startsWith('fr');

  useEffect(() => {
    fetch('/.auth/me')
      .then((r) => r.json())
      .then((d) => {
        const p = d.clientPrincipal as Principal;
        setPrincipal(p);
        setLoaded(true);
        if (p?.userRoles?.includes('attendee')) {
          window.location.href = '/';
        }
      })
      .catch(() => setLoaded(true));
  }, []);

  if (!loaded) return null;

  const signedIn = !!principal;
  const email = principal?.userDetails || '';

  const t = {
    title: isFr ? "Vous n'êtes pas sur la liste d'invités" : 'You are not on the invite list',
    signedInAs: isFr ? 'Connecté en tant que' : 'Signed in as',
    notSignedIn: isFr
      ? "Vous n'êtes pas connecté. Connectez-vous pour vérifier votre accès."
      : 'You are not signed in. Sign in to check your access.',
    signIn: isFr ? 'Se connecter' : 'Sign in',
    tryAnother: isFr ? 'Essayer avec un autre compte' : 'Try another account'
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-bg-base text-white">
      <div className="max-w-lg text-center">
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-6">{t.title}</h1>
        {signedIn ? (
          <>
            <p className="text-gray-300 mb-2">{t.signedInAs}</p>
            <p className="text-brand-red font-mono mb-8">{email}</p>
            <a href="/.auth/logout?post_logout_redirect_uri=/not-invited"
               className="inline-block px-6 py-3 border border-white/30 rounded-full hover:bg-white/5 transition">
              {t.tryAnother}
            </a>
          </>
        ) : (
          <>
            <p className="text-gray-300 mb-8">{t.notSignedIn}</p>
            <a href="/.auth/login/aad?post_login_redirect_uri=/"
               className="inline-block px-6 py-3 bg-brand-red rounded-full hover:opacity-90 transition">
              {t.signIn}
            </a>
          </>
        )}
      </div>
    </div>
  );
}
